import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";
import { IMarker } from "utils/geo";
// import NumericInterval from "utils/NumericInterval";
import {
  IOfferPreview,
  // EDispositionId,
  // EOffersSorting,
  // EOfferAge,
} from "utils/offer";
import { IWatchdogState } from "utils/search";
// import { IDispositionItemConfig } from "config/dispositions";

type TInput = {
  watchdogFilter: IWatchdogState;
  currentPage?: number;
};

type TOutput = {
  count: number; // offers count
  offers: Array<IOfferPreview>;
  markers: Array<IMarker>;
};

export default class FindWatchdogApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.POST;
  allowedStatusCodes = [409];

  resolveUri(): string {
    return `/fe-api/watchdog-find`;
  }

  mapRequestData({
    // area,
    // filterState,
    // bounds,
    // // conveniences,
    // // dispositions,
    // // price,
    // sorting,
    // // offerAge,
    // pageIndex,
    watchdogFilter,
    currentPage = 0,
  }: TInput): any {
    const {
      dispositions = [],
      conveniences = [],
      bounds,
      furnishing = [],
      acreageFrom = 0,
      acreageTo = 1000000,
      priceFrom = 0,
      priceTo = 100000000,
      offerTypeId = 1,
    } = watchdogFilter;

    return {
      acreage_from: acreageFrom,
      acreage_to: acreageTo,
      added_before: "",
      bounds: {
        north_east: bounds.northEast,
        south_west: bounds.southWest,
      },
      conveniences,
      // dispositions: dispositions
      //   ? pipe(
      //       map((x: IDispositionItemConfig) => x.apiIds),
      //       flatten,
      //       uniq,
      //     )(dispositions)
      //   : [],
      dispositions:
        dispositions.length > 0 && dispositions.some((x) => x !== null)
          ? dispositions
          : [],
      furnishing,
      is_price_commision_free: null,
      limit: 100,
      // offer_type_id: "1",
      offer_type_id: offerTypeId, // mean both categories
      page: currentPage + 1,
      price_from: priceFrom,
      price_to: priceTo,
      query: "",
      sort_by: null,
      test_1: null,
      test_2: null,
    };
  }

  mapResponseData(_: number, data: any): TOutput {
    return {
      count: parseInt(data.count),
      offers: data.offers.map(
        (x: any): IOfferPreview => ({
          id: x.id,
          area: x.acreage,
          description: x.description,
          dispositionId: x.disposition_id,
          geocoords: { lat: x.lat, lng: x.lng },
          photos: x.photos,
          rentalPrice: x.price_rental,
          commissionPrice: x.price_commission,
          depositPrice: x.price_deposit,
          monthlyFeesPrice: x.price_monthly_fee,
          publishedAt: x.published_at,
          seo: x.seo,
          street: x.street,
          village: x.village,
          villagePart: x.village_part,
          conveniences: x.conveniences || [],
          floorLevel: x.floor_level,
          availableFrom: x.available_from ? x.available_from.date : null,
          priceNote: x.price_note,
          offerTypeId: x.offer_type_id,
          adminUrl: x.url_admin,
          showScamWarn: x.show_scam_warning,
          specialFlag: null,
          isContacted: x.is_contacted,
          absoluteUrl: x.absolute_url,
        }),
      ),
      markers: [],
    };
  }
}
